import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { TaxesMetrics } from "@/components/Taxes/Metrics";

function TaxesMetricsContent() {
  return <TaxesMetrics />;
}

function RouteComponent() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <TaxesMetricsContent />
    </Suspense>
  );
}

export const Route = createFileRoute("/_authenticated/taxes/metrics/")({
  component: RouteComponent,
  staticData: { page: "tax" },
});
